import { useMemo } from "react";
import { DateTime } from "luxon";

export const calculateProgressFromDates = (
  now: DateTime,
  to?: string | null,
  from?: string | null
) => {
  if (!to || !from) {
    return 0;
  }
  const totalSecondsPending = Math.abs(
    DateTime.fromISO(to).diff(DateTime.fromISO(from)).as("seconds")
  );

  const secondsSinceStarted = Math.abs(
    now.diff(DateTime.fromISO(from)).as("seconds")
  );

  return Math.min(secondsSinceStarted / totalSecondsPending, 1);
};

export function useTodoCircleProps(props: {
  expireAt: string | null;
  createdAt: string;
}) {
  const now = DateTime.local();
  const isExpired = useMemo(
    () => !!(props.expireAt && DateTime.fromISO(props.expireAt) < now),
    [now, props.expireAt]
  );
  const percentCompleted = useMemo(
    () => calculateProgressFromDates(now, props.expireAt, props.createdAt),
    [now, props.expireAt, props.createdAt]
  );
  return { isExpired, percentCompleted };
}
